const Gender = {
  NONE: 0,
  MALE: 1,
  FEMALE: 2,
}


export default Gender
